(ns iris.posts.helpers
  (:require
   [clojure.string :as string]
   [iris.posts.common :refer [REF_HTAG_RE
                              REF_FREF_RE
                              REF_PREF_RE
                              OLD_REF_PREF_RE_STR
                              OLDER_REF_PREF_RE_STR]]))

(defn encode-post-actions-state [status qc hidden locked]
  (cond-> ""
    (or (= status "P")
        (= status "R")
        (= status "Q")
        (= status "S")
        (= status "T")) (str status)
    (true? qc) (str "q")
    (true? hidden) (str "h")
    (true? locked) (str "l")))

(defn decode-post-actions-state [state]
  (when (and (string? state) (not-empty state))
    (let [s (set state)]
      (cond-> {:qc (contains? s "q")
               :isHidden (contains? s "h")
               :isLocked (contains? s "l")}
        (contains? s "P") (assoc :status "P")
        (contains? s "R") (assoc :status "R")
        (contains? s "Q") (assoc :status "Q")
        (contains? s "S") (assoc :status "S")
        (contains? s "T") (assoc :status "T")))))

(defn post-ref-preview-body-html [post]
  (string/replace (str (or (get-in post [:content :body])
                           (get-in post [:content :excerpt])
                           ""))
                  #"<a[^>]*>([^<]+)</a>"
                  "$1"))

(defn normalize-post-ref-ruid [ruid]
  (let [ruid (when (some? ruid)
               (if (keyword? ruid) (name ruid) (str ruid)))]
    (when-not (string/blank? ruid)
      (string/replace ruid #"^@+" "@"))))

(defn post-ref-href->ruid [href]
  (when-not (string/blank? href)
    (let [href (str href)]
      (or
       (when-let [[_ thread post] (re-find #"(?:^|/)t/([^#?]+)#@?([^#?]+)" href)]
         (normalize-post-ref-ruid (str "@" post "+" thread)))
       (when-let [[_ post thread] (re-find #"(?:^|/)p/@?([^/?#+]+)\+([^/?#]+)" href)]
         (normalize-post-ref-ruid (str "@" post "+" thread)))))))

(defn post-full-anchor-id [post]
  (when-let [id (:id post)]
    (if (string/starts-with? id "@")
      (subs id 1)
      id)))

(defn post-thread-anchor-id [post]
  (when-let [id (:id post)]
    (if-let [thread-idx (and (:thread post) (string/index-of id (:thread post)))]
      (let [post-end (if (and (pos? thread-idx)
                              (= "+" (subs id (dec thread-idx) thread-idx)))
                       (dec thread-idx)
                       thread-idx)]
        (subs id 1 post-end))
      (subs id 1))))

(defn add-ws-to-refs-in-data [r v ws]
  (assoc-in r v
            (-> (get-in r v)
                (string/replace REF_HTAG_RE (str "<a href=\"/h/$1." ws "\" class=\"ref htag\">"))
                (string/replace REF_FREF_RE (str "<a href=\"$1." ws "\" class=\"ref fref\">"))
                (string/replace REF_PREF_RE "<a href=\"/t/$2#$1\" class=\"ref pref\">")
                (string/replace OLD_REF_PREF_RE_STR "<a href=\"/t/$1#$2\" class=\"ref pref\">")
                (string/replace OLDER_REF_PREF_RE_STR "<a href=\"/t/$1#OP\" class=\"ref pref\">"))))

(defn add-ws-to-refs [data ws]
  (mapv
   #(if (or (> (get-in % [:counts :tags]) 0) (> (get-in % [:counts :refs]) 0))
      (cond (= (:level %) 1)
            (-> %
                (add-ws-to-refs-in-data [:content :body] ws)
                (add-ws-to-refs-in-data [:content :title] ws))
            (= (:level %) 2)
            (-> %
                (add-ws-to-refs-in-data [:content :body] ws)))
      %)
   data))

(defn post-screening-scopes [posts]
  (->> posts
       (mapcat (fn [post]
                 (concat
                  [(when-let [ip (get-in post [:author :ip])]
                     (str "^" ip))
                   (when-let [cc (get-in post [:author :cc])]
                     (str ":" cc))
                   (:forum post)]
                  (vals (get-in post [:author :eid])))))
       (filter #(and (some? %) (not (string/blank? (str %)))))
       distinct
       vec
       not-empty))

(defn missing-screening-scopes [db scopes]
  (let [in-flight (get-in db [:posts :screening-status-in-flight] #{})
        requested (get-in db [:posts :screening-status-requested] #{})]
    (->> scopes
         (filter #(and (some? %) (not (string/blank? (str %)))))
         distinct
         (remove #(contains? in-flight %))
         (remove #(contains? requested %))
         vec
         not-empty)))

(defn reply-display-data [post fb-replies]
  (let [n (or (:n fb-replies)
              (get-in post [:counts :replies])
              0)]
    {:n n
     :t (:t fb-replies)
     :message (cond
                (> n 1) (str n " replies")
                (> n 0) (str n " reply")
                :else "no replies")}))

(defn screening-statuses-by-ruid [result-data]
  (cond
    (and (map? result-data) (:ruid result-data))
    {(keyword (:ruid result-data)) result-data}

    (map? result-data)
    (reduce-kv (fn [acc ruid status]
                 (if (map? status)
                   (assoc acc (keyword ruid) (assoc status :ruid (or (:ruid status) (name ruid))))
                   acc))
               {}
               result-data)

    (sequential? result-data)
    (->> result-data
         (filter map?)
         (keep (fn [status]
                 (when-let [ruid (:ruid status)]
                   [(keyword ruid) status])))
         (into {}))

    :else
    {}))

(defn ws-from-board-scope [board]
  (when-let [[_ ws] (re-find #"\.([A-Z]{3})$" (str board))]
    ws))

(defn get-scopes-from-query-params [qp]
  (let [board-ws (ws-from-board-scope (:board qp))
        ws (or board-ws (:ws qp))]
    (->
     (cond-> {}
       (:tag qp) (assoc :tag (str "#" (:tag qp)))
       (:user qp) (assoc :user (str "=" (:user qp)))
       ws (assoc :ws (str "." ws))
       (:cc qp) (assoc :cc (str ":" (:cc qp)))
       (:ip qp) (assoc :ip (str "^" (:ip qp)))
       (:geo qp) (assoc :geo (:geo qp))
       (:cookie qp) (assoc :cookie (:cookie qp))
       (:bfp qp) (assoc :bfp (:bfp qp))
       (:dfp qp) (assoc :dfp (:dfp qp))
       (:ua qp) (assoc :ua (:ua qp))
       (:mime qp) (assoc :mime (:mime qp))
       (:lang qp) (assoc :lang (:lang qp))
       (:thread qp) (assoc :thread (str "+" (:thread qp)))
       (:board qp) (assoc :board (:board qp))
       (:eid qp) (assoc :eid (:eid qp))
       (:id qp) (assoc :id (:id qp))
       (:level qp) (assoc :level (str "level" (:level qp))))
     vals
     vec)))
